import { useMemo } from "react";
import { getWeekdayDates } from "./weekdayUtils";
import type { WeekInfo } from "./useWeekManagement";

export function useWeekdayLabels(
  selectedView: "PERSONAL" | "TEAM",
  selectedWeekData: WeekInfo | null,
  availableWeeks: WeekInfo[],
  lastEndedWeek: Date[],
  insightsGranularity: "week" | "month" = "week"
): string[] {
  const weekdayLabels = useMemo(() => {
    if (insightsGranularity === "month") {
      return ["Mon", "Tue", "Wed", "Thu", "Fri"];
    }
    const weekdayDates = getWeekdayDates(
      selectedView,
      selectedWeekData,
      availableWeeks,
      lastEndedWeek
    );
    const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdayDates.map((date) => dayNames[date.getDay()]);
  }, [
    selectedView,
    selectedWeekData,
    availableWeeks,
    lastEndedWeek,
    insightsGranularity,
  ]);

  return weekdayLabels;
}
